import { dynamicKeyValueStore } from "@/utils/dynamicKeyValueStore";

export const AUTOCOMPLETE_SUGGESTIONS_LOG_LS_KEY = "autoCompleteSuggestionsAcceptanceLog";
export const LOG_LENGTH = 10;

export const logAutoCompleteSuggestionAcceptance = ({ isAccepted }) =>
    dynamicKeyValueStore.set(
        AUTOCOMPLETE_SUGGESTIONS_LOG_LS_KEY,
        JSON.stringify(
            JSON.parse(
                dynamicKeyValueStore.get(AUTOCOMPLETE_SUGGESTIONS_LOG_LS_KEY) ||
                    JSON.stringify(new Array(LOG_LENGTH).fill(false))
            )
                .concat([isAccepted])
                .slice(-LOG_LENGTH)
        )
    );
